import { CircularProgress } from "@material-ui/core";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { showLoader } from "../../redux/actions/action_loader";
import { getDevice, isFirefox, isIOSDevice } from "../../utils/getDevice";
import CustomerFeedback from "../CustomerFeedback/CustomerFeedback";
import "./VideoVerification.css";
import "./VideoVerificationNewUI.css";
import { isNewUI } from "../../utils/handleProgress";
import DotsLoader from "../Loader/DotsLoader/DotsLoader";
import AllowAccessAndroid from "../POSV_New_Ui/AllowAccessAndroid/AllowAccessAndroid";
import AllowAccessIOS from "../POSV_New_Ui/AllowAccessIOS/AllowAccessIOS";
import { playVoiceOver } from "../../utils/handleVoiceAndLang";

class VideoVerification extends Component {
  mediaRecorder;
  model;
  faceDetectionInt;
  state = {
    proposerFirstname: localStorage.getItem("proposerFirstname"),
    productName: localStorage.getItem("productName"),
    policyNumber: localStorage.getItem("policyNumber"),
    showVideoLoader: true,
    vidHeight: 240,
    vidWidth: 240,
    faceDetected: false,
    showMandatoryErr: false,
    loading: false,
    faceDetctionVideoStarted: false,
    accessDenied: false,
  };

  componentDidMount = async () => {
    // this.model = await window.facemesh.load();
    // this.startVideo();
  };

  componentWillUnmount = () => {
    this.stopCamera();
  };

  componentDidUpdate(prevProps, prevState) {
    if (isNewUI()) {
      if (this.state.loading !== prevState.loading && !this.state.loading) {
        this.handleEffect();
      }
    }
  }

  handleEffect() {
    if (!this.state.loading) {
      // playVoiceOver("video-verification-aud", "videoverification");
    }
  }

  stopCamera = () => {
    const video = document.getElementById("video-verify");
    if (video && video.srcObject) {
      console.log(video.srcObject.getVideoTracks());
      video.pause();
      video.srcObject.getVideoTracks()[0].stop();
    }
  };

  startVideo = () => {
    let videoWidth = 240;
    let videoHeight = 240;
    if (isIOSDevice()) {
      videoWidth = 150;
      videoHeight = 150;
    }
    if (navigator?.platform == "MacIntel") {
      videoWidth = 150;
      videoHeight = 150;
      console.log("isMac : ", navigator?.platform == "MacIntel");
    }
    if (isNewUI()) {
      videoWidth = 320;
      videoHeight = 240;
    }

    this.setState({
      vidHeight: videoHeight,
      vidWidth: videoWidth,
      loading: true,
    });
    let constraintObj = {
      audio: true,
      video: {
        facingMode: "user",
        width: videoWidth,
        height: videoHeight,
      },
    };
    console.log("Is iOS : ", isIOSDevice(), constraintObj);

    const video = document.getElementById("video-verify");
    video.style.visibility = "visible";
    video.style.display = "block";
    // video.style.borderRadius = "100%";
    video.setAttribute("autoplay", "");
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");

    navigator.mediaDevices
      .getUserMedia(constraintObj)
      .then((stream) => {
        window.localStream = stream;
        video.srcObject = window.localStream;
        if(!isNewUI()) {
          this.setState({
            showVideoLoader: false,
            loading: false,
            accessDenied: false,
          });
        }
        this.mediaRecorder = new MediaRecorder(stream);
        // this.setState({enableStartBtn:true,loadingCamera:false})
        if(!isNewUI()){
          this.setState({enableStartBtn:true,loadingCamera:false, faceDetctionVideoStarted:true})
        }
      })
      .catch((err) => {
        let errMessage = "Unable to start Video";
        if (err.name == "NotReadableError") {
          errMessage = "Unable to get Audio/Video stream";
        }
        if (err.name == "NotAllowedError") {
          errMessage =
            "Permission Denied! Please grant permission for accessing Mic and Camera";
        }
        console.log(err.name, errMessage);
        this.setState({
          showVideoLoader: false,
          videoPlayingErr: true,
          loading: false,
          accessDenied: true,
        });
        // this.setState({ streamingErr:true,streamErrMsg:errMessage,enableStartBtn:false,loadingCamera:false })
      });

    video.addEventListener("loadeddata", async () => {
      if (isNewUI()) {
        let timeoutTimer = 0
        if(isIOSDevice()) {
          timeoutTimer = 500
        }
        setTimeout(() => {
          this.setState({
            showVideoLoader: false,
            loading: false,
            accessDenied: false,
            enableStartBtn:true,
            loadingCamera:false, 
            faceDetctionVideoStarted:true
          });
        },timeoutTimer)
        // this.faceDetectionInt = setInterval(async () => {
        //   try {
        //     const prediction = await this.model.estimateFaces(video, false);
        //     this.setState({ loading: false, faceDetctionVideoStarted: true });

        //     if (prediction.length === 1) {
        //       // console.log('single face detected !', prediction)
        //       this.setState({ faceDetected: true });
        //       prediction.forEach((pred) => {
        //         let boxSize =
        //           pred.boundingBox.bottomRight[0] - pred.boundingBox.topLeft[0];
        //         let topLeft0 = pred.boundingBox.topLeft[0];
        //         let topLeft1 = pred.boundingBox.topLeft[1];
        //         let bottomRight0 = pred.boundingBox.bottomRight[0];
        //         let bottomRight1 = pred.boundingBox.bottomRight[1];
        //         // console.log("PREDs : ", prediction)
        //         // console.log("BOX SIZE : ", boxSize)
        //         if (boxSize < 95 || boxSize > 143) {
        //           this.setState({ faceDetected: false });
        //           // console.log("Bounding Box : ", boxSize)
        //         } else if (
        //           topLeft0 < 7 ||
        //           topLeft0 > 100 ||
        //           bottomRight0 > 260 ||
        //           bottomRight0 < 140 ||
        //           topLeft1 < 50 ||
        //           bottomRight1 > 250
        //         ) {
        //           // console.log("Face Out of Box : ", prediction)
        //           // console.log("Box Size : ", boxSize)
        //           this.setState({ faceDetected: false });
        //         } else if (prediction[0].faceInViewConfidence < 1) {
        //           // console.log("Face Covered ")
        //           this.setState({ faceDetected: false });
        //         }
        //       });
        //     } else {
        //       // console.log('Multipleface detected !', prediction)
        //       this.setState({ faceDetected: false });
        //     }
        //   } catch (err) {
        //     console.log(err);
        //   }
        // }, 40);
      }
    });
  };

  handleLoader = (state) => {
    this.props.showLoader(state);
  };

  captureImage = () => {
    const { vidHeight, vidWidth } = this.state;
    const videoEl = document.getElementById("video-verify");
    const canvasEl = document.createElement("canvas");
    canvasEl.width = vidWidth;
    canvasEl.height = vidHeight;
    // canvasEl.width = videoEl.width
    // canvasEl.height = videoEl.height
    canvasEl.getContext("2d").drawImage(videoEl, 0, 0, vidWidth, vidHeight);
    let image = canvasEl.toDataURL("image/jpeg", 1.0);
    return image;
  };

  handleMandatoryErrMsgDisplay = (bool) => {
    this.setState({ showMandatoryErr: bool });
  };

  getClassNameForVideoEl = () => {
    if (isFirefox()) {
      if (getDevice() === "mobile") {
        return "video-verify-firefox-mobile";
      } else {
        return "video-verify-firefox";
      }
    } else {
      return "video-verify-chrome";
    }
  };

  getFaceCircleClass = () => {
    const { faceDetected } = this.state;
    if (faceDetected) {
      return "face-circle green-crcl";
    } else {
      return "face-circle red-crcl";
    }
  };

  getAccessDeniedComponent = () => {
    if (isIOSDevice()) {
      return <AllowAccessIOS startVideo={this.startVideo} />;
    } else {
      return <AllowAccessAndroid startVideo={this.startVideo} />;
    }
  };

  render() {
    const {
      accessDenied,
      proposerFirstname,
      productName,
      policyNumber,
      showVideoLoader,
      showMandatoryErr,
      faceDetected,
      loading,
      faceDetctionVideoStarted,
    } = this.state;
    return (
      <>
        {isNewUI() ? (
          <>
            <audio className="aud-el-hide" id="video-verification-aud"></audio>
            {accessDenied && (
              <div className="access-denied-cntnr">
                {this.getAccessDeniedComponent()}
              </div>
            )}
            <div className="posv2ui-video-cntnr">
              <video
                className="posv2 vposv-video"
                id="video-verify"
                // width="240"
                // height="240"
                // style={{ width: "240", height: "240" }}
                preload={"auto"}
                autoPlay
                loop
                muted
              ></video>
              {/* <div className="face-circle-cntnr">
                <div className={this.getFaceCircleClass()}></div>
              </div> */}
              {/* <div className="facetext">
                {this.props.t("Position_face_inside_circle")}
              </div> */}
              {/* {loading && <DotsLoader msg={'Please wait...'} />} */}
            </div>
          </>
        ) : (
          <div className="custmr-details-consent">
            <div className="vposv-que-details">
              <div className="vposv-cust-details">
                <div className="vposv-cust-name">
                  <h4>Name</h4>
                  <p>{proposerFirstname}</p>
                </div>
                <div className="vposv-cust-product">
                  <h4>Product</h4>
                  <p>{productName}</p>
                </div>
                <div className="vposv-cust-proposal">
                  <h4>Policy no.</h4>
                  <p>{policyNumber}</p>
                </div>
              </div>
              <div className="vposv-cust-video-cntnr">
                {/* <div className='vposv-video' ></div> */}
                <video
                  className="vposv-video"
                  id="video-verify"
                  width="240"
                  height="240"
                  // style={{ width: "240", height: "240" }}
                  preload={"auto"}
                  autoPlay
                  loop
                  muted
                ></video>
                {showVideoLoader && (
                  <div className="video-loading-progress">
                    <CircularProgress />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {isNewUI() ? (
          <>
            <div
              className={
                showMandatoryErr
                  ? "vposv-2-que mandatory-err-cls"
                  : "vposv-2-que"
              }
            >
              <p className="posv2-ans-que-heading">
                {this.props.t("read_details_and_provide_response")}
                <br />
                {showMandatoryErr ? (
                  <small className="required" style={{ textAlign: "center" }}>
                    Please answer all the questions marked with *
                    {/* {this.state.errorMsg} */}
                    {/* {this.props.t(`${this.state.errorMsg}`)} */}
                  </small>
                ) : null}
              </p>

              <CustomerFeedback
                vposv={true}
                containerClass={"vposv-que"}
                handleLoader={this.handleLoader}
                captureImage={this.captureImage}
                handleMandatoryErrMsgDisplay={this.handleMandatoryErrMsgDisplay}
                // faceDetected={faceDetected}
                faceDetected={true}
                loadingVerficationVideo={!faceDetctionVideoStarted}
                startVideo={this.startVideo}
                stopVideo={this.stopCamera}
              />
            </div>
          </>
        ) : (
          <>
            <CustomerFeedback
              vposv={true}
              containerClass={"vposv-que"}
              handleLoader={this.handleLoader}
              captureImage={this.captureImage}
              faceDetected={true}
              loadingVerficationVideo={loading}
              handleMandatoryErrMsgDisplay={this.handleMandatoryErrMsgDisplay}
              startVideo={this.startVideo}
              stopVideo={this.stopCamera}
            />
          </>
        )}
      </>
    );
  }
}

export default compose(
  withRouter,
  connect(null, { showLoader }),
  withTranslation()
)(VideoVerification);
